import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { NotFoundGuard } from '@freelancer/404';
import { AuthGuard } from '@freelancer/auth-guard';
import { AppEmptyComponent } from 'app/app-empty.component';
import { VerificationsDocumentsComponent } from './verifications-documents/verifications-documents.component';
import { VerificationsHeaderComponent } from './verifications-header.component';
import { VerificationsUploadComponent } from './verifications-upload/verifications-upload.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [NotFoundGuard],
    component: AppEmptyComponent,
  },
  {
    path: ':url',
    canActivate: [AuthGuard],
    component: VerificationsHeaderComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: VerificationsDocumentsComponent,
      },
      {
        path: 'upload',
        component: VerificationsUploadComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VerificationsRoutingModule {}
